import { useBucket } from '@mc/experiments-react'
import { trackSignInClicked, trackForgotPasswordClicked } from '../events'
import {
  getLastLoginMethod,
  setAuthAttemptFlag,
  LoginMethod,
} from '../utils/lastLoginMethod'

export const CE_LAST_LOGIN_REMINDER_EXPERIMENT_NAME =
  'post-pw-ce-3448-last-login-reminder'

export const useLoginReminder = () => {
  const bucket = useBucket(CE_LAST_LOGIN_REMINDER_EXPERIMENT_NAME)
  const lastLoginMethod = getLastLoginMethod()
  const isExperimentParticipant = !!bucket

  const handleLoginMethodClick = (method: LoginMethod, action?: string) => {
    if (isExperimentParticipant) {
      trackSignInClicked({
        action,
        loginMethod: method,
        lastLoginMethod,
      })

      setAuthAttemptFlag('login')
    }
  }

  const handleForgotPasswordClick = () => {
    if (isExperimentParticipant) {
      trackForgotPasswordClicked({ lastLoginMethod })
    }
  }

  return {
    isExperimentParticipant,
    isVariant: bucket === 'variant_1',
    lastLoginMethod,
    handleLoginMethodClick,
    handleForgotPasswordClick,
  }
}
